import * as React from "react";
import { config } from "../../../config";
import Col from "../../Common/Col";
import Row from "../../Common/Row";
import PageTitle from "../PageTitle";
import { paths } from "../../../router";
import Alert from "react-bootstrap/Alert";
import Link from "../../Navigation/Links/Link";
import { MailLink } from "../../Navigation/Links/ExternalLink";

type State = {
  hasError: boolean;
  error?: any;
};

/**
 * This is an error boundary which shows errors thrown synchronously by React.
 */
export default class ErrorBoundary extends React.Component<{}, State> {
  constructor(props: {}) {
    super(props);
    this.state = { hasError: false };
  }

  public componentDidCatch(error: any, _info?: any) {
    this.setState({
      hasError: true,
      error
    });
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Row>
          <Col md={9}>
            <PageTitle title="Error" />
            <Alert variant="danger" className="margin-top-sm">
              <h2>Oh no! Something went wrong!</h2>
              <p>
                {this.state.error.message} Please go to the home screen and try again, or contact
                ECMWF Service Desk <MailLink email={config.serviceDeskEmail} /> for assistance.
              </p>
              <Link to={paths.root}>
                <div
                  className="margin-top-sm danger"
                  onClick={() => this.setState({ hasError: false })}
                >
                  Go home
                </div>
              </Link>
            </Alert>
          </Col>
        </Row>
      );
    }

    return this.props.children;
  }
}
